<script>
import crud from '@/crud/index/index'
import resources from './resources'

export default {
  name: 'privacy-policy',
  mixins: [crud, resources]
}
</script>

<template lang="pug">
  page(title="Política de Privacidade", icon="")
    .col-xs-12.content
      .container-fluid
        section.gadget-agenda-estatisticas.white-bg.wrapper.full-width.gadget
          .actions
          div(style="overflow-y: scroll; max-height:350px; padding: 20px", v-for="policy in policies")
            div(v-html="policy.document_legal")
</template>



// WEBPACK FOOTER //
// src/app/professional/privacy-policy/index/index.vue